import { FolderAttachmentDataProviderItemType } from '../constants';
import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentDataProviderItemType from 'owa-service/lib/contract/AttachmentDataProviderItemType';

function isFolderItem(item: AttachmentDataProviderItem): boolean {
    return (
        item.__type === FolderAttachmentDataProviderItemType ||
        item.Type === AttachmentDataProviderItemType.Folder
    );
}

/**
 * Returns the list with the folders in the beginning and files after them
 * @param items The list of items
 */
export default function moveFoldersToTheBeginning(
    items: AttachmentDataProviderItem[]
): AttachmentDataProviderItem[] {
    const folderItems = items.filter(isFolderItem);
    const fileItems = items.filter(item => !isFolderItem(item));

    return folderItems.concat(fileItems);
}
